import React from 'react';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

const FormSection = ({
  title, subtitle, children, className
}) => {
  const sectionSubtitle = subtitle ? (
    <div className="formSectionSubtitle">
      { Monet.I18n.getResourcesByKey(subtitle) }
    </div>
  ) : null;

  return (
    <CrudContext.Consumer>
      {
        ({ isGrid, entity }) => (
          isGrid ? children : (
            <div data-testid={`${entity}FormSection`} className={`formSection ${className}`}>
              <div className="formSectionTitle">
                { Monet.I18n.getResourcesByKey(title) }
              </div>
              { sectionSubtitle }
              <div className="formSectionFields">
                { children }
              </div>
            </div>
          )
        )
      }
    </CrudContext.Consumer>
  );
};

FormSection.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

FormSection.defaultProps = {
  subtitle: null,
  className: ''
};

export default FormSection;
